angular.module('invoice')
    .controller('InvoiceProjectDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, InvoiceProject, InvoiceProjectConst, Principal) {
        this.$onInit = () => {
            this.item = data
            this.canReadInvoiceProjectBgt = Principal.hasAnyAuthority(['ROLE_INVOICE_PROJECT_BGT_READ', 'ROLE_ADMIN'])
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = InvoiceProject.update(this.item).$promise
            } else {
                promise = InvoiceProject.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast(InvoiceProjectConst.eventUpdate)
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
    })
